import React, { useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';

export function PaymentForm({ amount, onSuccess, onError, selectedPlan, currentSubscription }) {
  const stripe = useStripe();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe) return;

    setLoading(true);
    try {
      // Get the session ID first
      let sessionId;
      try {
        sessionId = await onSuccess();
      } catch (sessionError) {
        // Handle authentication errors
        if (sessionError.message.includes('Authentication failed') || 
            sessionError.message.includes('Invalid token')) {
          // Force user to log in again
          alert('Your session has expired. Please log in again to continue.');
          navigate('/login');
          return;
        }
        
        // Handle subscription errors
        if (sessionError.redirectToAccount) {
          alert(sessionError.error || 'You already have an active subscription.');
          navigate('/account');
          return;
        }
        
        throw sessionError;
      }

      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        sessionId: sessionId
      });

      if (error) {
        onError(error);
      }
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: '100%', margin: '1rem auto' }}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <button 
          type="submit" 
          disabled={!stripe || loading}
          style={{ 
            width: '50%',
            padding: "14px 18px", 
            boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
            transition: "all 0.3s ease",
            background: "linear-gradient(135deg, var(--tertiary-color), var(--secondary-color))",
            color: "white",
            fontWeight: "bold",
            fontSize: "1.1rem",
            transform: "translateY(0)",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            position: "relative",
            overflow: "hidden"
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
          onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
        >
          {loading ? 'Processing...' : 'Proceed to Payment'}
        </button>
      </form>
    </div>
  );
}